import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

/**
 * Checks if is string and contains no "${}"
 * @returns
 */
export function IsSafeString(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'isSafeString',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(value: string, args: ValidationArguments) {
                    if (typeof value != 'string') return false;
                    if (value.match(/\$\{.*\}/)) return false;
                    if (value.includes('�')) return false; // Claaaasssic Windows CSV formatting

                    return true;
                },
            },
        });
    };
}
